import _, { get } from "lodash";
import { createContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CustomModal from "../../../../app/common-components/CustomModal.jsx";
import { hideOffCanvas, setIsOffCanvasOpen } from "../../../../app/commonSlice.js";
//import {getFiltersToShow} from "./Constants.js";


import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import ButtonComponent from "../../../../app/common-components/ButtonComponent.jsx";
import CustomOffCanvas from "../../../../app/common-components/CustomOffCanvas.jsx";
import DiscardChanges from "../../../../app/common-components/DiscardChanges.jsx";
import Input from "../../../../app/common-components/form/input.jsx";
import Spinners from "../../../../app/common-components/Spinner.jsx";
import CompleteTableData from '../../../../app/common-components/Table/CompleteTableData.jsx';
import { useCommonAlert } from "../../../../app/utilities/helpers.js";
import { updateSelectedApp } from "../../../../Modules/configuration/HomeSlice.js";
import {
  AppList,
  BusinessEdit,
  BusinessInfoSave,
  Businessdelete,
  businessInfoCount,
  businessInfoList,
  getTableFilter,
  resetDataSave,
  resetresponseData,
} from "../cmdb-overview/CMDBSlice.js";
import "../styles.scss";

export const ProjectContext = createContext();

const BussinesInfoConfig = () => {
  const dispatch = useDispatch();
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const location = useLocation();
  const {
    businessInfoData,
    businessInfoDataCount,
    bILoading,
    bICountLoading,
    Applist,
    ApplistLoading,
    deleteLoading,
    DataSave,
    saveLoading,
    responseData,
    tableFilterData,
  } = useSelector((state) => state.cmdbId);
  const { userName, userRole } = useSelector(
    (state) => state.common.loggedUser
  );
  const { state: locationState } = useLocation();
  useEffect(() => {
    // console.log(locationState);
    if (locationState?.appLabel) {
      const homeNavApp = {
        label: `${locationState.appLabel}[${locationState.appCode}]`,
        value: locationState.appCode,
        id: locationState.id,
      };
      dispatch(updateSelectedApp(homeNavApp));
    } else {
      dispatch(updateSelectedApp({}));
    }
  }, [dispatch]);
  const notAllowedRoles = [
    "Application Manager",
    "Department Head",
    "Division Head",
  ];
  const userAccess = !userRole.some((role) => notAllowedRoles.includes(role));
  const [fields, setFields] = useState([""]);
  const [currentAction, setCurrentAction] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showServerForm, setShowServerForm] = useState(false);
  const [showServerAddBtn, setShowServerAddBtn] = useState(true);
  const { efficiency } = useSelector((state) => state);
  const [showApplicationCode, setShowApplicationCode] = useState("");
  const [showApplicationName, setShowApplicationName] = useState([]);
  const [showBusinessDepartment, setShowBusinessDepartment] = useState("");
  const [showBusinessDivision, setShowBusinessDivision] = useState("");
  const [showBusinessCapability, setShowBusinessCapability] = useState("");
  const [showBusinessActivity, setShowBusinessActivity] = useState([""]);
  const [showBusinessSubActivity, setShowBusinessSubActivity] = useState([]);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [getId, setGetId] = useState("");
  const [editingId, setEditingId] = useState();
  const isNavigated = _.get(location, "state.isNavigated", false);
  const navigate = useNavigate();

  const [divisionOption, setDivisionOption] = useState([]);
  const [departmentOption, setDepartmentOption] = useState([]);
  const [selectOptionDiv, setSelectOptionDiv] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({
    division: [],
    department: [],
  });
  const [BusinessDepartmenterrorMessage, setBusinessDepartmentErrorMessage] =
    useState("");
  const [BusinessCapabilityerrorMessage, setBusinessCapabilityErrorMessage] =
    useState("");
  const [BusinessActivityerrorMessage, setBusinessActivityErrorMessage] =
    useState([]);
  const [BusinessDivisionerrorMessage, setBusinessDivisionErrorMessage] =
    useState([]);
  const [showDepartmentError, setshowDepartmentError] = useState("");
  const [showCapabilityError, setshowCapabilityError] = useState("");
  const [showActivityError, setshowActivityError] = useState([]);
  const [showDivisionError, setshowDivisionError] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [totalPageCount, settotalPageCount] = useState();
  const [isFilterClicked, setIsFilterClicked] = useState(false);
  const [appliedFilter, setAppliedFilter] = useState({
    division: [],
    department: [],
  });


  const [searchInputValue, setSearchInputValue] = useState("");
  const getPayload = (
    filterClicked = isFilterClicked,
    filters = appliedFilter
  ) => {
    const tablePayload = {
      pageNumber: currentPageNo,
      itemsPerPage: pageLimit,
      payload: {
        businessDepartment: filterClicked
          ? _.map(filters.department, (obj) => obj.value)
          : [],
        businessDivision: filterClicked
          ? _.map(filters.division, (obj) => obj.value)
          : [],
        keyword: searchInputValue,
      },
    };
    return tablePayload;
  };
  const fetchData = (payload) => {
    dispatch(businessInfoList(payload));
    dispatch(businessInfoCount(payload));
    dispatch(getTableFilter());
    // dispatch(userAccessReviewTableCount(payload));
  };
  useEffect(() => {
    const payload = getPayload();
    fetchData(payload);
  }, [pageLimit, currentPageNo, searchInputValue]);

  useEffect(() => {
    if (!isNaN(businessInfoData?.totalCount)) {
      const calculatedPageCount = Math.ceil(businessInfoData?.totalCount / pageLimit);
      const finalPageCount =
        calculatedPageCount !== 0 ? calculatedPageCount : 1;
      settotalPageCount(finalPageCount);
    }
  }, [businessInfoData, pageLimit]);

  const handlePageLimitChange = (newPageLimit) => {
    setPageLimit(newPageLimit);
    const payload = getPayload();
    fetchData(payload);
    setCurrentPageNo(0);
  };
  const handlePageNoChange = (pageNumber) => {
    setCurrentPageNo(pageNumber);
  };
  const onSearch = (e) => {
    setCurrentPageNo(0);

    setSearchInputValue(e);
  };
  const [Serverstate, setServerstate] = useState({
    applicationConfig: false,
    appConfigTitle: "",
    cmdbId: "",
    serverList: {},
    BusnissTableListData: {},
  });
  const serverListData = get(efficiency, "appConfig.bussinessTableData", []);
  const [state, setState] = useState({
    limit: 10,
    page: 0,
    count: 0,
    totalPages: "",
    importModal: false,
    newApplication: false,
    projectId: "",
    file: "",
    fileInfo: "",
    deleteModalOpen: false,
    loading: false,
    loadPage: false,
    id: "",
    cmdbId: "",
    appList: [],
    departmentInputState: false,
    capabilityInputState: false,
    activityInputState: false,
    divisionInputState: false,
    addBodyOpenCancel: false,
    conformationPop: false,
  });
  const [stateAlert, setStateAlert] = useState({
    modalOpen: false,
    deleteId: "",
    //modalOpen: false,
  });

  const specialcharRegex = /^[a-zA-Z][a-zA-Z0-9&\-_ ]*$/;
  const textRegex = /^[ a-zA-Z0-9][a-zA-Z0-9,.\-'()@&!%/ ]*$/; ///^[a-zA-Z0-9&\-.,'() ]+$/;

  const mapValues = (inputJson, mappingObject) => {
    const mappedValues = [];

    inputJson.forEach((item) => {
      const key = item.value;
      if (mappingObject[key]) {
        const values = mappingObject[key];
        values.forEach((value) => {
          //using 'some' is check the condition true or false
          if (!mappedValues.some((mappedItem) => mappedItem.value === value)) {
            mappedValues.push({ label: value, value });
          }
        });
      }
    });

    return mappedValues;
  };
  const onFilterChange = (selectedOption, key) => {
    if (key == "department") {
      if (selectedOption.length === 0) {
        // No department selected — show all divisions
        const allDivisions = [];
        Object.values(tableFilterData ? tableFilterData : {}).forEach((values) => {
          values.forEach((value) => {
            if (!allDivisions.some((item) => item.value === value)) {
              allDivisions.push({ label: value, value });
            }
          });
        });
        setDivisionOption(allDivisions);
        setSelectedFilters({ department: [], division: allDivisions });
        return;
      }
      const mappedJson = mapValues(selectedOption, tableFilterData);
      setDivisionOption(mappedJson);
      setSelectedFilters((prev) => ({ ...prev, department: selectedOption, division: [] }));
      return;
    }
    const filter = _.cloneDeep(selectedFilters);
    filter[key] = selectedOption;
    setSelectedFilters(filter);
  };

  const onFilter = () => {
    setIsFilterClicked(true);
    setAppliedFilter(selectedFilters);
    const payload = getPayload(true, selectedFilters);
    fetchData(payload);
  };

  let keysArray = [];
  let valuesArray = [];
  useEffect(() => {
    keysArray = Object.keys(tableFilterData ? tableFilterData : {}).map(
      (ids, index) => ({
        label: ids,
        value: ids,
      })
    );
    setDepartmentOption(keysArray);
    setSelectOptionDiv(tableFilterData);

    // Collect all unique division values from all departments
    const allDivisions = [];
    Object.values(tableFilterData ? tableFilterData : {}).forEach((values) => {
      values.forEach((value) => {
        if (!allDivisions.some((item) => item.value === value)) {
          allDivisions.push({ label: value, value });
        }
      });
    });
    setDivisionOption(allDivisions);
    setSelectedFilters((prev) => ({
      ...prev,
      division: allDivisions,
    }));
  }, [tableFilterData]);
  var department = [];
  var division = [];
  const getFiltersToShow = (onFilterChange, selectedFilters) => {
    division = selectedFilters.division.filter((item) =>
      divisionOption.some((valItem) => valItem.value === item.value)
    );
    department = selectedFilters.department.filter((item) =>
      departmentOption.some((valItem) => valItem.value === item.value)
    );
    if (department.length === 0) {
      department = [];
    }
    const filtersToShow = [
      {
        options: departmentOption,
        changeFunc: onFilterChange,
        placeholder: "Department",
        key: "department",
        value: department,
        searchPlaceHolder: "Search Department",
      },
      {
        options: divisionOption,
        changeFunc: onFilterChange,
        placeholder: "Division",
        key: "division",
        value: division,
        searchPlaceHolder: "Search Division",
      },
    ];
    // if (division.length === 0 && department.length === 0) {
    //   onFilter();
    // }

    return filtersToShow;
  };

  const handleSearch = (query) => {};
  const [numFields, setNumFields] = useState(1);

  const handleAddField = () => {
    if (showBusinessActivity.length < 6) {
      setShowBusinessActivity([...showBusinessActivity, ""]);
    }
  };
  const handleRemoveField = (indexToRemove) => {
    const businessActivity = showBusinessActivity.filter(
      (_, index) => index !== indexToRemove
    );
    const acitivityError = _.filter(
      showActivityError,
      (err, index) => index !== indexToRemove
    );
    const activityErrorMsg = _.filter(
      BusinessActivityerrorMessage,
      (msg, index) => index !== indexToRemove
    );
    setBusinessActivityErrorMessage(activityErrorMsg);
    setshowActivityError(acitivityError);
    setShowBusinessActivity(businessActivity);
  };
  const columns = [
    {
      Header: "Business Department",
      accessor: "businessDepartment",
      className: "text-start",
      thClassName: "text-center businesCofgTabAlign",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Department Head",
      accessor: "departmentHead",
      className: "text-start",
      thClassName: "text-center businesCofgTabAlign",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Business Division",
      accessor: "businessDivision",
      className: "text-start",
      thClassName: "text-center businesCofgTabAlign",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Division Head",
      accessor: "divisionHead",
      className: "text-start",
      thClassName: "text-center businesCofgTabAlign",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Application Name",
      accessor: "applications",
      thClassName: "text-center businesCofgTabAlign",
      Cell: ({ value }) => {
        if (Array.isArray(value)) {
          return <>{value.length !== 0 ? value.join(", ") : "-"}</>;
        } else {
          return <>{value ? value : "-"}</>;
        }
      },
    },
    {
      Header: "Business Capability",
      accessor: "businessCapability",
      className: "text-start",
      thClassName: "text-center businesCofgTabAlign",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },

    {
      Header: "Business Activity",
      accessor: "businessActivity",
      className: "text-start",
      thClassName: "text-center businesCofgTabAlign",
      Cell: ({ value }) => {
        return value && value.length > 0 ? (
          <ol>
            {_.map(value, (val, index) => (
              <li key={index}>
                {index + 1}. {val}
              </li>
            ))}
          </ol>
        ) : (
          "-"
        );
      },
    },
    {
      Header: "Actions",
      accessor: "Action",
      className: "text-center",
      thClassName: "text-center",
      disableSortBy: true,
      tdclassname: "text-center",

      Cell: (row) => (
        <div className="actionsBtn d-flex justify-content-center">
          {" "}
          <div className="actcol">
            <FiEdit
              title="Edit"
              className={`iconStyleActions ${!userAccess ? "disabled" : ""}`}
              data-testid="editIcon"
              onClick={() => {
                if (userAccess) {
                  setServerstate((state) => ({
                    ...state,
                    applicationConfig: true,
                    appConfigTitle: "Application",
                    editId: row.row.original.id,
                  }));
                  openserver("edit", row.row.original);
                }
              }}
            />
          </div>
          <div className="actcol">
            <FiTrash2
              title="Delete"
              data-testid={"deleteIcon"}
              className={`iconStyleActions ${!userAccess ? "disabled" : ""}`}
              onClick={() => {
                if (userAccess) {
                  onDeleteData(row.row.original.id);
                }
              }}
            />
          </div>
        </div>
      ),
    },
  ];

  let applistpayload = {
    userName,
    userRole,
  };
  const openserver = async (action, row) => {
    dispatch(AppList(applistpayload));
    if (action == "edit") {
      setShowApplicationName(row.applications);
      dispatch(BusinessEdit({ id: row.id }));
      setShowBusinessDivision(row.businessDivision);
      setShowBusinessDepartment(row.businessDepartment);
      setShowBusinessCapability(row.businessCapability);
      let businessActivity = !_.isEmpty(row.businessActivity)
        ? row.businessActivity
        : [""];
      setShowBusinessActivity(businessActivity);
      setshowDivisionError(false);
      setshowDepartmentError(false);
      setshowCapabilityError(false);
      setshowActivityError([]);
      setGetId(row.id);
      setCurrentAction("edit");
      setEditingId(row.id);
    } else {
      setShowApplicationCode("");
      setShowApplicationName([]);
      setShowBusinessDivision("");
      setShowBusinessDepartment("");
      setShowBusinessCapability("");
      setShowBusinessActivity([""]);
      setShowBusinessSubActivity([]);
      setCurrentAction("add");
      setEditingId(0);
      setFields([]);
      setGetId(0);
    }
    // setShowServerForm(true)
    setShowServerAddBtn(false);
    dispatch(
      setIsOffCanvasOpen({
        isDrilldownOpen: true,
        isDropDownhide: true,
      })
    );
  };

  useEffect(() => {
    if (responseData.length !== 0) {
      const filteredBussiness = responseData.map((responseData) => ({
        //appName: responseData.appName,
        businessDepartment: responseData.businessDepartment,
        businessCapability: responseData.businessCapability,
        businessActivity: responseData.businessActivity,
        businessDivision: responseData.businessDivision,
        id: responseData.id,
      }));

      setGetId(filteredBussiness.map((data) => data.id).join(","));

      if (filteredBussiness.length > 0) {
        setCurrentAction("edit");
        dispatch(resetresponseData());
      } else {
        setFields([]);
      }

      setCurrentAction("edit");
    }
  }, [responseData]);

  const saveAPICall = (payload) => {
    const tablePayload = getPayload();
    dispatch(BusinessInfoSave(payload)).then((resp) => {
      if (resp.payload.statusCodeValue == 200) {
        callCommonAlert("success", resp.payload.body);
        fetchData(tablePayload);
        hideCommonAlert();
        addserverclose();
        dispatch(resetDataSave());
      } else if (resp.payload.statusCodeValue == 400) {
        callCommonAlert("error", resp.payload.body);
        hideCommonAlert();
      } else if (resp.payload.error) {
        callCommonAlert("error", "Something went wrong. Please try again.");
        hideCommonAlert();
      }
    });
  };
  const handleSave = () => {
    let hasError = false;

    if (showBusinessDepartment.trim() === "") {
      setBusinessDepartmentErrorMessage(
        "Business Department should not be empty"
      );
      setshowDepartmentError(true);
      setState({
        ...state,
        departmentInputState: true,
      });
      hasError = true;
    } else if (showBusinessDepartment.length < 5) {
      setBusinessDepartmentErrorMessage(
        "Business Department length should be minimum 5"
      );
      setshowDepartmentError(true);
      setState({
        ...state,
        departmentInputState: true,
      });
      hasError = true;
    } else if (!specialcharRegex.test(showBusinessDepartment)) {
      setBusinessDepartmentErrorMessage(
        "Please enter valid Business Department"
      );
      setshowDepartmentError(true);
      setState({
        ...state,
        departmentInputState: true,
      });
      hasError = true;
    }

    if (showBusinessCapability.trim() === "") {
      setBusinessCapabilityErrorMessage(
        "Business Capability should not be empty"
      );
      setshowCapabilityError(true);
      setState({
        ...state,
        capabilityInputState: true,
      });
      hasError = true;
    } else if (!textRegex.test(showBusinessCapability.trim())) {
      setBusinessCapabilityErrorMessage(
        "Please enter valid Business Capability"
      );
      setshowCapabilityError(true);
      setState({
        ...state,
        capabilityInputState: true,
      });
      hasError = true;
    }

    _.map(showBusinessActivity, (activity, index) => {
      if (activity.length == 0) {
        BusinessActivityerrorMessage[index] =
          "Business Activity should not be empty";
        setBusinessActivityErrorMessage(BusinessActivityerrorMessage);
        showActivityError[index] = true;
        setshowActivityError(showActivityError);
        setState({
          ...state,
          activityInputState: true,
        });
        hasError = true;
      } else if (activity.trim().length == 0) {
        BusinessActivityerrorMessage[index] =
          "Please enter a valid Business Activity";
        setBusinessActivityErrorMessage(BusinessActivityerrorMessage);
        showActivityError[index] = true;
        setshowActivityError(showActivityError);
        setState({
          ...state,
          activityInputState: true,
        });
        hasError = true;
      } else if (!textRegex.test(activity)) {
        BusinessActivityerrorMessage[index] =
          "Please enter valid Business Activity";
        setBusinessActivityErrorMessage(BusinessActivityerrorMessage);
        showActivityError[index] = true;
        setshowActivityError(showActivityError);
        setState({
          ...state,
          activityInputState: true,
        });
        hasError = true;
      }
    });

    if (showBusinessDivision.trim() === "") {
      setBusinessDivisionErrorMessage("Business Division should not be empty");
      setshowDivisionError(true);
      setState({
        ...state,
        divisionInputState: true,
      });
      hasError = true;
    } else if (showBusinessDivision.length < 5) {
      setBusinessDivisionErrorMessage(
        "Business Division length should be minimum 5"
      );
      setshowDivisionError(true);
      setState({
        ...state,
        departmentInputState: true,
      });
      hasError = true;
    } else if (!specialcharRegex.test(showBusinessDivision)) {
      setBusinessDivisionErrorMessage("Please enter valid Business Division");
      setshowDivisionError(true);
      setState({
        ...state,
        divisionInputState: true,
      });
      hasError = true;
    }
    if (!hasError) {
      const payload = {
        applications: showApplicationName,
        businessDivision: showBusinessDivision,
        businessDepartment: showBusinessDepartment,
        businessCapability: showBusinessCapability,
        id: editingId ? editingId : 0,
        businessActivity: showBusinessActivity.filter(
          (activity) => activity.length > 0
        ),
        updatedBy: "",
        updatedDt: "",
      };
      saveAPICall({ userName, payload });
    }
  };

  const addserverclose = async () => {
    dispatch(hideOffCanvas(false));
    setState({
      ...state,
      activityInputState: false,
    });
    addBodyClose();
    setshowCapabilityError(false);
    setshowActivityError([]);
    setshowDivisionError(false);
    setshowDepartmentError(false);
    setShowServerAddBtn(true);
    setShowServerForm(false);
    setFields(fields.slice(0, -40));
    setState((state) => ({
      ...state,
      conformationPop: false,
    }));
  };

  const onDeleteData = (id) => {
    setState((state) => ({
      ...state,
      projectId: id,
      deleteModalOpen: true,
    }));
    setStateAlert((stateAlert) => ({
      ...stateAlert,
      modalOpen: true,
      deleteId: id,
    }));
  };

  const deleteId = () => {
    dispatch(
      Businessdelete({ id: stateAlert.deleteId, userName: userName })
    ).then((resp) => {
      if (resp.payload.statusCodeValue == 400) {
        callCommonAlert("error", _.get(resp, "payload.body") ? resp.payload.body : "This business department is linked with the application, so unable to delete");
      } else {
        const payload = getPayload();
        fetchData(payload);
        callCommonAlert("success",_.get(resp, "payload.body") ? resp.payload.body : "Business Info Deleted Succesfully" );
      }
      removeDelModel();
      hideCommonAlert();
    });
  };

  const removeDelModel = () => {
    setStateAlert((stateAlert) => ({
      ...stateAlert,
      modalOpen: false,
    }));
  };
  const modalBody = () => (
    <>
      <h4 className="delete-h"> Delete Business Info</h4>
      {deleteLoading ? (
        <Spinners />
      ) : (
        <div>
          <p>
            Are you sure you would like to delete the Business Info
            Configuration?
          </p>
          <div className="btnswrap btn-dlt">
            <ButtonComponent
              text="Cancel"
              className={"cancelBtnStyle btn btn-primary"}
              onClick={handleClose}
            />
            <ButtonComponent
              text="Delete"
              className={"btnStyle btn btn-primary"}
              data-testid="deleteBtn"
              onClick={() => deleteId()}
            />
          </div>
        </div>
      )}
    </>
  );

  const handleClose = () => {
    setStateAlert({
      ...stateAlert,
      modalOpen: false,
    });
    hideCommonAlert();
  };
  const addmodalCancel = () => {
    setState((state) => ({
      ...state,
      addBodyOpenCancel: true,
    }));
  };
  const addBodyClose = () => {
    setState({
      ...state,
      addBodyOpenCancel: false,
    });
  };
  const addBodyCancel = () => {
    return (
      <>
        <DiscardChanges
          title={currentAction === "edit" ? "edit" : "add"}
          discardClick={addserverclose}
          cancelClick={addBodyClose}
        />
      </>
    );
  };



  const clickbtn = () => {
    setState({
      ...state,
      activityInputState: false,
      divisionInputState: false,
      conformationPop: false,
    });
    setshowCapabilityError(false);
    setshowActivityError([]);
    setshowDivisionError(false);
    setshowDepartmentError(false);
    return openserver("add", 0);
  };
  const onNavigate = (e, url) => {
    e.preventDefault();
    navigate(url);
  };
  const navigateToRole = (e) => {
    onNavigate(
      e,
      "/configuration/cmdb/BusinessInfoConfig/roleAllocation"
    );
  };

  const Btnadd = [
    {
      text: "Add",
      function: clickbtn,
      className: !userAccess ? " accessDisabled " : "solid-btn",
      disabled: !userAccess,
    },
    {
      text: "Role Allocation",
      function: navigateToRole,
      className: !userAccess ? " accessDisabled " : "solid-btn",
    },
  ];

  function BusinessDepartmentChange(e) {
    // setShowBusinessDepartment(e.target.value);
    const value = e.target.value;
    if (value.startsWith(" ")) {
      setShowBusinessDepartment(value.trimStart());
    } else {
      setShowBusinessDepartment(value);
    }
    setshowDepartmentError(false);
    setState((state) => ({
      ...state,
      conformationPop: true,
    }));
  }

  const BusinessCapabilityChange = (e) => {
    // setShowBusinessCapability(e.target.value);
    const value = e.target.value;
    if (value.startsWith(' ')) {
      setShowBusinessCapability(value.trimStart());
    } else {
      setShowBusinessCapability(value);
    }
    setshowCapabilityError(false);
    setState((state) => ({
      ...state,
      conformationPop: true,
    }));
  };

  const BusinessActivityChange = (e, index) => {
    const businessActivity = _.cloneDeep(showBusinessActivity);
    // businessActivity[index] = e.target.value;
    const value = e.target.value;
    if (value.startsWith(" ")) {
      const val = value.trimStart();
      businessActivity[index] = val;
    } else {
      businessActivity[index] = e.target.value;
    }
    setShowBusinessActivity(businessActivity);
    BusinessActivityerrorMessage[index] = "";
    setBusinessActivityErrorMessage(BusinessActivityerrorMessage);
    showActivityError[index] = false;
    setshowActivityError(showActivityError);
    setState((state) => ({
      ...state,
      conformationPop: true,
    }));
  };

  const BusinessDivisionChange = (e) => {
    // setShowBusinessDivision(e.target.value);
    const value = e.target.value;
    if (value.startsWith(" ")) {
      setShowBusinessDivision(value.trimStart());
    } else {
      setShowBusinessDivision(value);
    }
    setBusinessDivisionErrorMessage(false);
    setshowDivisionError(false);
    setState((state) => ({
      ...state,
      divisionInputState: false,
      conformationPop: true,
    }));
  };

  const checkDisablePlusButton = () => {
    let returnVal = false;
    _.map(showBusinessActivity, (activity) => {
      if (activity.length == 0) {
        returnVal = true;
      }
    });
    if (showBusinessActivity.length == 6) {
      returnVal = true;
    }
    return returnVal;
  };
  return (
    <>
      <ProjectContext.Provider value={{ state, setState }}>
        <CustomModal
          modalOpen={stateAlert.modalOpen}
          modalBody={modalBody}
          modalTitle={"Delete Configuration"}
          closeBtn={false}
          closeBtnFuc={handleClose}
        />
        <CustomModal
          modalOpen={state.addBodyOpenCancel}
          modalBody={addBodyCancel}
          modalHide={addmodalCancel}
          closeBtn={true}
          closeBtnFuc={addBodyClose}
        />
      </ProjectContext.Provider>

      <div className="row">
        <div id="tableCol">
          <div className="grid-table business-table">
            {/* {bILoading ? (
              <Spinners />
            ) : ( */}
            <CompleteTableData
              isLoading={bILoading || bICountLoading}
              data={businessInfoData?.data || []}
              tbodyClass={"text-business"}
              columns={columns}
              onDelete={onDeleteData}
              listCount={businessInfoData?.totalCount}
              pageLimit={pageLimit}
              onSearch={onSearch}
              onPageNoChange={handlePageNoChange}
              onPageLimitChange={handlePageLimitChange}
              searchKey={searchInputValue}
              filtersToShow={getFiltersToShow(onFilterChange, selectedFilters)}
              onFilter={onFilter}
              isTableFilterDisabled={
                !Object.values(selectedFilters || {}).flat().length
              }
              selectedFilterValues={selectedFilters}
              showFilter={true}
              totalPageCount={totalPageCount}
              curentPageNumber={currentPageNo}
              btnData={!showServerForm ? Btnadd : null}
              moveSearchToEnd={true}
              moveFilterToStart={true}
            />
            {/* )} */}
          </div>
        </div>
        <CustomOffCanvas className="custom-off-canvas paddingBusiness">
          <h3
            className="flowhead p-0-5"
            id="updatehead"
            style={{ display: "block" }}
          >
            {currentAction === "edit"
              ? "Update Business Info"
              : "Add New Business Info"}{" "}
          </h3>
          {saveLoading ? (
            <Spinners />
          ) : (
            <>
              <Row className="m-0">
                <Col>
                  <Input
                    type="text"
                    label="Business Department*"
                    name="Business Department"
                    error={showDepartmentError}
                    errorMessage={BusinessDepartmenterrorMessage}
                    placeholder="Enter Business Department"
                    autoComplete={"off"}
                    onChange={BusinessDepartmentChange}
                    containerClassName={"frmgroup validate default-input"}
                    min={5}
                    maxLength="50"
                    value={showBusinessDepartment}
                  />
                </Col>
                <Col>
                  <Input
                    type="text"
                    label="Business Division*"
                    name="Business Division"
                    error={showDivisionError}
                    errorMessage={BusinessDivisionerrorMessage}
                    placeholder="Enter Business Division"
                    autoComplete={"off"}
                    value={showBusinessDivision}
                    onChange={BusinessDivisionChange}
                    containerClassName={"frmgroup validate default-input"}
                    min={5}
                    maxLength="50"
                  />
                </Col>
              </Row>
              <Row className="m-0">
                <Col>
                  <Input
                    type="text"
                    label="Business Capability*"
                    name="Business Capability"
                    error={showCapabilityError}
                    errorMessage={BusinessCapabilityerrorMessage}
                    placeholder="Enter Business Capability"
                    autoComplete={"off"}
                    onChange={BusinessCapabilityChange}
                    containerClassName={"frmgroup validate default-input"}
                    value={showBusinessCapability}
                    maxLength="255"
                  />
                </Col>
                {_.map(showBusinessActivity, (businessActivity, index) => {
                  return (
                    <Col sm={6}>
                      <Input
                        type="text"
                        label={`Business Activity ${index + 1}${
                          index === 0 ? "*" : ""
                        }`}
                        name={`Business Activity ${index + 1}`}
                        error={showActivityError[index]}
                        key={index}
                        errorMessage={BusinessActivityerrorMessage[index]}
                        placeholder={`Enter Business Activity ${index + 1}`}
                        autoComplete={"off"}
                        onChange={(e) => BusinessActivityChange(e, index)}
                        containerClassName={"frmgroup validate default-input "}
                        value={businessActivity}
                        index={index}
                        showRemoveButton={index > 0 ? true : false}
                        handleRemoveField={handleRemoveField}
                        inputClassName={index > 0 ? "businessOverlap" : ""}
                        parentDivClassName="input-wrapper"
                        endIcon={true}
                        maxLength="500"
                      />
                    </Col>
                  );
                })
              }
            </Row>
            <Row className="m-0">
              <Col>
              <div>
                {checkDisablePlusButton() ? <OverlayTrigger
                  placement="top"

                  overlay={<Tooltip className='tooltipHeader '>{`${showBusinessActivity.length == 6 ? "Reached limit to add the Business Activity" : "Kindly provide the details in the existing Business Activity field to proceed with adding the new Business Activity"}`}</Tooltip>}
                >
              <button 
                  disabled={checkDisablePlusButton()}
                className="Plusaddbutton"
              >
                +
              </button>
            </OverlayTrigger> : <button className="Plusaddbutton" onClick={handleAddField}>+</button>}
</div>

              </Col>
            </Row>
            <Row className="m-0">
              <Col></Col>
              <Col>
                <div className="server-btn businessall">
                  <ButtonComponent
                    text="Cancel"
                    className={"cancelBtnStyle"}
                    onClick={() => {
                      // addserverclose();
                      if(state.conformationPop){
                        addmodalCancel();
                      }else{
                        addserverclose();
                      }
                    }}
                  />
                  <ButtonComponent
                    text="Save"
                    onClick={() => {
                      handleSave();
                    }}
                  />
                </div>
              </Col>
            </Row>
            </>
          )}
        </CustomOffCanvas>
      </div>
    </>
  );
};

export default BussinesInfoConfig;

